var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-5",class:{'text-center': _vm.alignment === 'center',
                'text-left': _vm.alignment === 'left',
                'text-right': _vm.alignment === 'right',
                'text-center': _vm.alignment === undefined}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.$variables.v.theme.secondary}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }